import { Status } from '@assembly-js/design-system';
import React, { useMemo } from 'react';
import Stripe from 'stripe';

import { RefreshIcon, TrashIcon } from 'src/components/icons';
import { BankVerifyFormModel } from 'src/constants/componentTypes/paymentsTypes';
import { Action, BaseActionsMenu } from 'src/legacy/components/Dropdowns';
import { BankVerifyButton } from 'src/legacy/components/PaymentMethodForm/BankVerifyButton';
import { StripePaymentMethod } from 'src/types/payment';

interface Props {
  source: StripePaymentMethod;
  bankAccount: Stripe.BankAccount | undefined;
  onVerify?: (values: BankVerifyFormModel) => Promise<void>;
  isDefault?: boolean;
  onMakePrimaryMethod: (source: StripePaymentMethod) => void;
  onDeleteSource: (sourceId: string) => void;
}
export const PaymentSourceActions: React.FC<Props> = ({
  source,
  bankAccount,
  onVerify,
  isDefault,
  onMakePrimaryMethod,
  onDeleteSource,
}) => {
  const isSourceUnverifiedBank =
    source.object === 'bank_account' && source.status !== 'verified';
  const isUnverifiedBank = bankAccount && bankAccount.status !== 'verified';
  const showSourceVerifyAction =
    onVerify && (isSourceUnverifiedBank || isUnverifiedBank);

  /**
   * All payment method have a delete action, only primary methods have a make primary action
   * @returns list of actions in menu for payment method
   */
  const sourceActions = useMemo(() => {
    const actions: Action[] = isDefault
      ? []
      : [
          {
            name: 'Make primary method',
            onClick: () => onMakePrimaryMethod(source),
            icon: <RefreshIcon />,
          },
        ];
    actions.push({
      name: 'Delete',
      onClick: () => onDeleteSource(source.id),
      isDisabled: isDefault,
      tooltipLabel: 'Cannot delete primary payment method',
      icon: <TrashIcon />,
      isDelete: true,
    });
    return actions;
  }, [isDefault]);

  return (
    <div className="flex">
      {showSourceVerifyAction && (
        <>
          {bankAccount ? (
            <BankVerifyButton source={bankAccount} onVerify={onVerify} />
          ) : (
            source.object === 'bank_account' && (
              <BankVerifyButton source={source} onVerify={onVerify} />
            )
          )}
        </>
      )}
      <div className="flex">
        {!showSourceVerifyAction && isDefault && (
          <Status label="Default" status="neutral" />
        )}
        {!showSourceVerifyAction && (
          <BaseActionsMenu
            parentComponentType="toolbar"
            actions={sourceActions}
          />
        )}
      </div>
    </div>
  );
};
